module.exports = "/_next/static/images/b0b46ef25738673aa96a80655e2a6d2e-choose-maturity-period.png";